const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 1, 85), undefined, true, false, 1));
            }

            getTemplateName() {
                return `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`;
            }

            getSourceContext() {
                return new this.Source(``, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, ``);
            }
        }],
        [85, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 3, 83), undefined, true, false, 3));
                this.echo(`
    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 10, 84), undefined, true, false, 10));
                this.echo(`  `);
            }

            getTemplateName() {
                return `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, ``);
            }
        }],
        [83, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/input-group/input-group.twig`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 3);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/input-group/input-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, undefined, false, false, 5));
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, undefined, false, false, 6));
                this.echo(`      `);
            }

            getTemplateName() {
                return `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, ``);
            }
        }],
        [84, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/input-group/input-group.twig`, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, 10);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/input-group/input-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, undefined, false, false, 12));
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, undefined, false, false, 13));
                this.echo(`      `);
            }

            getTemplateName() {
                return `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1');

let template = env.loadTemplate('e651aa3e428cb6ce5f7191f16ed393982ad8d34a99011a25a96364aae11a6ae1');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/input-group/demo/input-group-demo.twig", args: context }
     );
     return rendered;;
};